import flatpickr from 'flatpickr';

export default class DatetimePickerWidget {
    constructor(el, options = {}) {
        this.el = el;
        this.options = {
            enableTime: false,
            dateFormat: 'Y-m-d',
            ...options
        };
        this.init();
    }

    init() {
        // Detect input type and adjust settings
        const inputType = this.el.getAttribute('type');

        if (inputType === 'datetime-local' || this.el.dataset.appDatetimepicker === 'datetime') {
            this.options.enableTime = true;
            this.options.dateFormat = 'd.m.Y H:i';
			this.options.time_24hr = true;
        } else if (inputType === 'time' || this.el.dataset.datetimepicker === 'time') {
            this.options.enableTime = true;
            this.options.noCalendar = true;

            this.options.dateFormat = 'H:i';
			this.options.time_24hr = true;
        } else {
			this.options.enableTime = false;
			this.options.dateFormat = 'd.m.Y';
		}

        // Initialize flatpickr
        this.picker = flatpickr(this.el, this.options);
    }

    destroy() {
        if (this.picker) {
            this.picker.destroy();
        }
    }
}
